/* Aktionen: Auto-Ende (gegen Seiten-Cache) + Einblend-Effekte der Startseiten-Sektion.
   Abgelaufene Aktions-Elemente werden clientseitig entfernt, auch wenn Shopify
   noch eine zwischengespeicherte Seite mit ihnen ausliefert. */
(function () {
  function aufraeumen() {
    var jetzt = Math.floor(Date.now() / 1000);
    var elemente = document.querySelectorAll('[data-aktion-ende]');
    for (var i = 0; i < elemente.length; i++) {
      var el = elemente[i];
      var ende = parseInt(el.getAttribute('data-aktion-ende'), 10);
      if (!ende || ende > jetzt) continue;
      var karte = el.closest('[data-aktion-karte]');
      if (karte) { karte.remove(); } else { el.remove(); }
    }
    var sektion = document.querySelector('[data-aktionen]');
    if (sektion && !sektion.querySelector('[data-aktion-karte]')) {
      var huelle = sektion.closest('section');
      if (huelle) huelle.remove();
    }
  }
  aufraeumen();

  /* Einblenden der Sektion beim ersten Sichtbarwerden */
  var bereich = document.querySelector('[data-aktionen]');
  if (bereich && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (eintraege[i].isIntersecting) {
          eintraege[i].target.classList.add('sichtbar');
          io.unobserve(eintraege[i].target);
        }
      }
    }, { threshold: 0.25 });
    io.observe(bereich);
  } else if (bereich) {
    bereich.classList.add('sichtbar');
  }
})();
